import type { FieldDiff, RankedSpace } from "../types";

function fmtPrice(v: number | null | undefined): string {
  if (v == null) return "—";
  return `R$ ${v.toLocaleString("pt-BR")}`;
}

function fmtList(arr: string[]): string {
  if (!arr.length) return "—";
  return arr.slice().sort().join(", ");
}

export function computeSpaceDiff(
  original: RankedSpace,
  fresh: RankedSpace,
): FieldDiff[] {
  const diffs: FieldDiff[] = [];

  const check = (field: string, label: string, prev: string, curr: string) => {
    if (prev !== curr)
      diffs.push({ field, label, previous: prev, current: curr });
  };

  check(
    "roomName",
    "Nome da sala",
    original.roomName ?? "—",
    fresh.roomName ?? "—",
  );
  check(
    "spaceName",
    "Espaço",
    original.spaceName ?? "—",
    fresh.spaceName ?? "—",
  );
  check(
    "monthlyPrice",
    "Preço mensal",
    fmtPrice(original.monthlyPrice),
    fmtPrice(fresh.monthlyPrice),
  );
  check(
    "capacity",
    "Capacidade",
    original.capacity != null ? `${original.capacity} pessoas` : "—",
    fresh.capacity != null ? `${fresh.capacity} pessoas` : "—",
  );
  check(
    "sizeM2",
    "Área",
    original.sizeM2 != null ? `${original.sizeM2} m²` : "—",
    fresh.sizeM2 != null ? `${fresh.sizeM2} m²` : "—",
  );
  check(
    "amenities",
    "Comodidades",
    fmtList(original.amenities ?? []),
    fmtList(fresh.amenities ?? []),
  );

  // Images: compare URLs as a sorted set
  const origImages = (original.images ?? []).slice().sort().join("|");
  const freshImages = (fresh.images ?? []).slice().sort().join("|");
  if (origImages !== freshImages) {
    diffs.push({
      field: "images",
      label: "Imagens",
      previous:
        original.images?.length != null
          ? `${original.images.length} imagem(ns)`
          : "—",
      current:
        fresh.images?.length != null
          ? `${fresh.images.length} imagem(ns)`
          : "—",
    });
  }

  return diffs;
}
